'use strict';

var React = require('react');
var reactIcons = require('@sravni/react-icons');
var reactUtils = require('@sravni/react-utils');
var ExpandCell_module = require('../styles/ExpandCell.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const Cell = ({ row }) => {
    const cx = reactUtils.useStyles(ExpandCell_module.default);
    return (row.getCanExpand() && (React__namespace.createElement("div", { "data-qa": "ExpandCell", className: cx('container'), onClick: row.getToggleExpandedHandler() }, row.getIsExpanded() ? React__namespace.createElement(reactIcons.Minus, { className: cx('icon') }) : React__namespace.createElement(reactIcons.Plus, { className: cx('icon') }))));
};
const ExpandColumn = {
    accessorKey: 'expander',
    header: '',
    size: 48,
    enableResizing: false,
    enableSort: false,
    enableSorting: false,
    enableColumnFilter: false,
    cell: Cell,
};

exports.ExpandColumn = ExpandColumn;
//# sourceMappingURL=ExpandColumn.js.map
